// @flow
import React from 'react';
import { Box } from 'grommet';
import DropdownItem from './DropdownItem';

type Props = {
    points: Array,
    lines: Array,
    onItemClick: Function,
}

const TextInputWithDropdown = (props: Props) => {
    const { points, lines, onItemClick } = props;

    return (
        <Box>
            { points.length > 0
                && (
                    <Box>
                        <h5
                            style={{ margin: '0px 10px', padding: '2px 5px', borderBottom: '1px solid #a7a7a7' }}
                        >
                            Намерени точки (до 5 резултата):
                        </h5>
                        {points.map((point) => (
                            <DropdownItem object={point} onClick={onItemClick} key={point.ref} />
                        ))}
                    </Box>
                )}
            { lines.length > 0
                && (
                    <Box>
                        <h5
                            style={{ margin: '0px 8px', padding: '2px 5px', borderBottom: '1px solid #a7a7a7' }}
                        >
                            Намерени линии (до 5 резултата):
                        </h5>
                        {lines.map((line) => <DropdownItem object={line} onClick={onItemClick} key={line.ref} />)}
                    </Box>
                )}
        </Box>
    );
};

export default TextInputWithDropdown;
